// extracted by mini-css-extract-plugin
export default {"wrapper":"Input_wrapper__j83m8","input":"Input_input__AMoGK","textarea":"Input_textarea__9amP2"};